// import Vue from 'vue'
// import App from './App.vue'
//
// Vue.config.productionTip = false
//
// new Vue({
//   render: h => h(App),
// }).$mount('#app')
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入ECharts
import * as echarts from 'echarts'
// 引入axios
// 引入WordEditor组件
import WordEditorPlugin from './plugins/plugin.js'
import requester from './request/requester'
// 全局注册WordEditor组件
Vue.use(WordEditorPlugin)

// 全局注册ElementUI组件
Vue.use(ElementUI)
// 将ECharts挂载到Vue原型上，方便全局使用
Vue.prototype.$echarts = echarts

// 将配置好的axios实例挂载到Vue原型上
Vue.prototype.$http = requester.request

new Vue({
  router,
  store,
  created() {
    // Initialize user from localStorage on app startup
    this.$store.dispatch('user/initializeUser');
  },
  render: h => h(App)
}).$mount('#app')

